<template>
  <div class="applications-main">
    <div class="application-card">
      <product-box v-for="(item, idx) in list" :key="'product-box-' +idx"
                   :focus-application="focusApplication"
                   :source-data="item">
      </product-box>
    </div>
  </div>
</template>
<style lang="less" type="text/less">
  .applications-main{
    width: 100%;
    height: 100%;
    box-sizing: border-box;
    padding-top: 16px;
    background: rgb(243,244,247);
    .application-card{
      width: 1056px;
      margin:  0 auto;
      background-color: #fff;
      box-sizing: border-box;
      padding: 32px 48px 12px 48px;
      height: 560px;
    }
  }
</style>
<script>
import ProductBox from '@/components/applications/ProductBox'
import {mapState} from 'vuex'
import {clone} from '@/assets/utils'
export default {
  name: 'ApplicationsHome',
  data () {
    return {
      focusApplication: '',
      list: []
    }
  },
  provide () {
    return {
      rootPlatform: this
    }
  },
  computed: {
    ...mapState({
      leftMenus: state => state.menus.leftMenus,
      productPermission: state => state.menus.productPermission,
      applicationStatusChange: state => state.menus.applicationStatusChange
    })
  },
  mounted () {
    this.setProductPermission()
  },
  methods: {
    setProductPermission () {
      const list = []
      this.leftMenus.forEach((menu) => {
        if (menu.children && menu.children.length && menu.path !== '/applications/home') {
          list.push(clone(menu))
        }
      })
      this.list = list
      console.log(list)
      console.log('-=-=-=-=-=')
    }
  },
  watch: {
    applicationStatusChange () {
      this.setProductPermission()
    }
  },
  components: {
    ProductBox
  }
}
</script>
